<template>
  <div style="display: inline-block;">
    <van-button
      @click="changeAttrition"
      size="small"
      :disabled="!this.selectOrders || this.selectOrders.length === 0"
      class="order-action"
    >申请减员</van-button>
    
    <van-dialog
      v-model="showApplyAttrition"
      title="请选择要减员的项目"
      show-cancel-button
      :beforeClose="beforeClose"
    >
      <van-checkbox-group v-model="paymentItemsDescChildSelect" style="margin-top:20px;">
        <van-cell-group>
          <van-cell
            :border="false"
            v-for="(item, index) in getPaymentItemsDescChildText()"
            clickable
            :key="item"
            :title="item"
            @click="toggle(index)"
          >
            <van-checkbox :name="item" ref="checkboxes" />
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-dialog>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import _ from "lodash";
import Vue from "vue";

Vue.use(Toast);

export default {
  name: "sby-apply-attrition",
  data: function() {
    return {
      paymentItemsDescChildSelect: [],
      showApplyAttrition: false,
      orderInfo: null,
      selectOrders: null
    };
  },
  props: {
    refresh: {
      type: Function,
      default: () => {
        return () => {};
      }
    },
    orders: {
      type: Array
    }
  },
  watch: {},
  mounted: function() {
    this.selectOrders = this.orders.filter(
      order => this.getPaymentItemsDescChild(order).length > 0
    );
    if (this.selectOrders === 0) {
      return;
    }
  },
  methods: {
    getPaymentItemsDescChild(orderInfo) {
      let paymentItemsDescChild = [];
      orderInfo.payment_items.forEach((item, index) => {
        if (
          orderInfo["item_" + item] &&
          ["added", "re_added", "added_service"].includes(orderInfo["item_" + item].status)
        ) {
          paymentItemsDescChild.push({
            name: item,
            text: orderInfo.payment_items_desc[index]
          });
        }
      });
      return paymentItemsDescChild;
    },
    getPaymentItemsDescChildText() {
      if (!this.selectOrders || this.selectOrders.length === 0) {
        return [];
      }
      let items = [];
      this.selectOrders.forEach(
        orderInfo =>
          (items = items.concat(
            this.getPaymentItemsDescChild(orderInfo).map(n => n.text)
          ))
      );

      return items;
    },
    toggle(index) {
      let that = this;
      that.$refs.checkboxes[index].toggle();
    },
    // 点击申请减员操作
    changeAttrition() {
      this.showApplyAttrition = !this.showApplyAttrition;
    },
    // 弹出框点击确认事件
    beforeClose(action, done) {
      if (action === "confirm") {
        if (
          !this.paymentItemsDescChildSelect ||
          this.paymentItemsDescChildSelect.length == 0
        ) {
          Toast("请至少选择一个需要减员的项目");
          done(false);
          return;
        }
        if (
          this.paymentItemsDescChildSelect.includes("公积金") &&
          this.getPaymentItemsDescChildText().includes("社保") &&
          !this.paymentItemsDescChildSelect.includes("社保")
        ) {
          Toast("减员公积金必须同时减员社保");
          done(false);
          return;
        }

        Dialog.confirm({
          message: `减员后即当月停止缴费，是否继续？`
        })
          .then(() => {
            this.selectOrders.forEach(orderInfo => {
              let finishedList = this.getPaymentItemsDescChild(
                orderInfo
              ).filter(item => {
                return this.paymentItemsDescChildSelect.includes(item.text);
              });
              finishedList = finishedList.map(n => n.name);
              if (finishedList.length == 0) {
                return;
              }
              this.$http
                .post("/api/order/applyFinished", {
                  id: orderInfo.id,
                  finished: finishedList
                })
                .then(response => {
                  Toast("申请成功");
                  done();
                  this.paymentItemsDescChildSelect = [];
                  this.refresh();
                });
            });
          })
          .catch(() => {
            done();
            this.paymentItemsDescChildSelect = [];
          });
      } else {
        done();
        this.paymentItemsDescChildSelect = [];
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/sby-apply-attrition.vue